import { LANDING_SCREEN } from "./landingAssets";

export const LANDING_HERO_SCREEN = {
  src: "/landing/screen-staff-overview.png",
  alt: "Сводка владельца в Бай.Спорт",
};

/** Три ключевых блока — текст + абстрактная иллюстрация (без скриншотов приложения). */
export const LANDING_STORY_SECTIONS = [
  {
    id: "branding",
    eyebrow: "Ваш бренд",
    title: "Портал полностью под ваш клуб",
    lead:
      "Логотип, цвета, обложка и экран при запуске PWA. Родители видят вашу секцию — не чужой сервис.",
    bullets: [
      "Аватар клуба и обложка шапки — в настройках за пару минут",
      "Тёмная и светлая тема под стиль клуба",
      "Splash при запуске — как нативное приложение",
    ],
    layout: "features",
    accent: "violet",
    defaultFeatureId: "brand-logo",
    features: [
      {
        id: "brand-logo",
        label: "Логотип",
        kind: "brand-logo",
        title: "Узнаваемый клуб",
        lines: ["Аватар в приложении", "Иконка на главном экране"],
      },
      {
        id: "brand-splash",
        label: "Запуск",
        kind: "brand-splash",
        title: "Экран приветствия",
        lines: ["Логотип и название", "Плавный вход в PWA"],
      },
      {
        id: "brand-theme",
        label: "Темы",
        kind: "brand-theme",
        title: "Светлая и тёмная",
        lines: ["Под цвета секции", "Единый стиль порталов"],
      },
    ],
  },
  {
    id: "social",
    eyebrow: "Только у Бай.Спорт",
    title: "Всё, что нужно клиентам",
    lead:
      "Расписание, абонемент и опрос «приду» на главной. Профиль со стеной и медалями, чат клуба и рейтинг группы — в приложении на телефоне.",
    bullets: [
      "Главная: остаток занятий, ближайшие тренировки и ответ тренеру",
      "Профиль спортсмена, стена и достижения",
      "Общий чат и соревнование за посещаемость в группе",
    ],
    layout: "features",
    accent: "sky",
    defaultFeatureId: "social-home",
    features: [
      {
        id: "social-home",
        label: "Главная",
        kind: "social-home",
        title: "Всё под рукой",
        lines: ["Абонемент и расписание", "Опрос «приду на тренировку»"],
      },
      {
        id: "social-profile",
        label: "Профиль",
        kind: "social-profile",
        title: "Стена и медали",
        lines: ["Достижения спортсмена", "Группа и рейтинг"],
      },
      {
        id: "social-chat",
        label: "Чат",
        kind: "social-chat",
        title: "Общение в клубе",
        lines: ["Чат группы и тренера", "Без звонков администратору"],
      },
      {
        id: "social-rating",
        label: "Рейтинг",
        kind: "social-rating",
        title: "Мотивация группы",
        lines: ["Посещаемость в соревновании", "Видно прогресс каждого"],
      },
    ],
  },
  {
    id: "manage",
    eyebrow: "CRM без головной боли",
    title: "Всё, что нужно для управления клубом",
    lead:
      "Сводка дня, календарь, клиенты, журнал и финансы — в одном кабинете на телефоне. Без Excel и десятка сервисов.",
    bullets: [
      "Сводка: ближайшие занятия и ответы на опрос",
      "Календарь, клиенты с фильтрами и абонементами",
      "Перекличка и учёт выручки с расходами",
    ],
    layout: "features",
    accent: "mint",
    defaultFeatureId: "manage-summary",
    features: [
      {
        id: "manage-summary",
        label: "Сводка",
        kind: "manage-summary",
        title: "День клуба",
        lines: ["Занятия и опрос «приду»", "Быстрые действия"],
      },
      {
        id: "manage-calendar",
        label: "Календарь",
        kind: "manage-calendar",
        title: "Расписание",
        lines: ["Тренировки и события", "По дням и группам"],
      },
      {
        id: "manage-clients",
        label: "Клиенты",
        kind: "manage-clients",
        title: "База спортсменов",
        lines: ["Группы и абонементы", "Фильтры и поиск"],
      },
      {
        id: "manage-journal",
        label: "Журнал",
        kind: "manage-journal",
        title: "Перекличка",
        lines: ["Отметка за секунды", "Списание с абонемента"],
      },
      {
        id: "manage-finance",
        label: "Финансы",
        kind: "manage-finance",
        title: "Деньги клуба",
        lines: ["Выручка и расходы", "Кто не оплатил"],
      },
    ],
  },
  {
    id: "journal",
    eyebrow: "Как выглядит журнал",
    title: "Занятие → отметки → абонемент",
    lead:
      "Три экрана одного сценария. Не схема — реальный кабинет.",
    bullets: [
      "Тренировка из расписания",
      "Отметки в журнале группы",
      "Остаток абонемента у вас и у родителя",
    ],
    layout: "features",
    accent: "violet",
    defaultFeatureId: "manage-journal",
    features: [
      {
        id: "manage-calendar",
        label: "Расписание",
        kind: "manage-calendar",
        src: LANDING_SCREEN.manageCalendar,
        phone: false,
        title: "Открыли занятие",
        lines: ["Календарь групп", "Состав на тренировку"],
      },
      {
        id: "manage-journal",
        label: "Журнал",
        kind: "manage-journal",
        src: LANDING_SCREEN.manageJournal,
        phone: false,
        title: "Отметили, кто пришёл",
        lines: ["Перекличка за секунды", "С телефона или с ноутбука"],
      },
      {
        id: "client-home",
        label: "Родители",
        kind: "social-home",
        src: LANDING_SCREEN.clientHome,
        phone: true,
        title: "Видят посещения сами",
        lines: ["Расписание и остаток", "Без вопросов в чате"],
      },
    ],
  },
  {
    id: "trainer",
    eyebrow: "День тренера",
    title: "До занятия, на тренировке, после",
    lead:
      "Один человек — одна секция. Кабинет помещается в телефон.",
    bullets: [
      "До: кто должен прийти",
      "На занятии: журнал и абонемент",
      "После: родители смотрят кабинет",
    ],
    layout: "features",
    accent: "violet",
    defaultFeatureId: "manage-journal",
    features: [
      {
        id: "staff-home",
        label: "Сводка",
        kind: "manage-summary",
        src: LANDING_SCREEN.staffOverview,
        phone: true,
        title: "Ближайшие занятия",
        lines: ["День тренера на одном экране", "Быстрый вход в журнал"],
      },
      {
        id: "manage-journal",
        label: "Журнал",
        kind: "manage-journal",
        src: LANDING_SCREEN.manageJournal,
        phone: false,
        title: "Отметки на занятии",
        lines: ["Кто пришёл", "Абонемент списался"],
      },
      {
        id: "client-home",
        label: "Родители",
        kind: "social-home",
        src: LANDING_SCREEN.clientHome,
        phone: true,
        title: "Кабинет секции",
        lines: ["Расписание и посещения", "Не общий WhatsApp"],
      },
    ],
  },
  {
    id: "club",
    eyebrow: "CRM клуба",
    title: "Владелец, тренер, родители",
    lead:
      "Разные роли — одна система. Не десять таблиц и чатов.",
    bullets: [
      "Сводка клуба для владельца",
      "Журнал для тренера",
      "Кабинет для родителей под ваш бренд",
    ],
    layout: "features",
    accent: "violet",
    defaultFeatureId: "manage-summary",
    features: [
      {
        id: "manage-summary",
        label: "Клуб",
        kind: "manage-summary",
        src: LANDING_SCREEN.manageOverview,
        phone: false,
        title: "Сводка дня",
        lines: ["Что требует внимания", "Занятия и оплаты"],
      },
      {
        id: "manage-finance",
        label: "Оплаты",
        kind: "manage-finance",
        src: LANDING_SCREEN.manageFinance,
        phone: false,
        title: "Абонементы и должники",
        lines: ["Кто без пакета", "Не Excel в конце месяца"],
      },
      {
        id: "client-home",
        label: "Родители",
        kind: "social-home",
        src: LANDING_SCREEN.clientHome,
        phone: true,
        title: "Кабинет клуба",
        lines: ["Расписание и абонемент", "Логотип вашей секции"],
      },
    ],
  },
];
